import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';

export function betslipOddsBoostsFactory(PALETTE) {
    return {
        OddsBoostBanner: {
            containerWrapper: {
                style: {
                    maxHeight: 'initial',
                },
            },
            container: {
                base: {
                    style: {
                        ...resolveBackground(PALETTE.BETSLIP_ODDS_BOOSTS_CONTAINER_BG),
                        borderRadius: PALETTE.BETSLIP_ODDS_BOOSTS_CONTAINER_BORDER_RADIUS,
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: PALETTE.BETSLIP_ODDS_BOOSTS_CONTAINER_BORDER_COLOR,
                    },
                },
                APPLIED: {
                    style: {
                        borderColor: PALETTE.BETSLIP_ODDS_BOOSTS_CONTAINER_APPLIED_BORDER_COLOR,
                    },
                },
                betBuilder: {
                    style: {
                        ...resolveBackground(PALETTE.BETSLIP_ODDS_BOOSTS_BB_CONTAINER_BG),
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0,
                        borderWidth: '1px 0 0',
                        borderColor: PALETTE.BETSLIP_ODDS_BOOSTS_CONTAINER_BB_BORDER_COLOR,
                    },
                },
            },
            boostIcon: {
                // a little bit confusing naming, for base we need to set styles only for APPLIED state and for all other states
                // we need to use disabled
                base: icon(PALETTE.BETSLIP_ODDS_BOOSTS_APPLIED_ICON_COLOR),
                disabled: icon(PALETTE.BETSLIP_ODDS_BOOSTS_ICON_COLOR),
            },
            title: {
                base: {
                    style: PALETTE.BETSLIP_ODDS_BOOSTS_TITLE_TEXT,
                },
                IN_USE: {
                    style: PALETTE.BETSLIP_ODDS_BOOSTS_IN_USE_TEXT,
                },
            },
            returnsText: {
                style: PALETTE.BETSLIP_ODDS_BOOSTS_RETURNS_TEXT,
            },
            actionButton: {
                base: {
                    style: {
                        base: PALETTE.BETSLIP_ODDS_BOOSTS_ACTION_BUTTON_TEXT,
                    },
                },
                AVAILABLE: {
                    style: {
                        base: PALETTE.BETSLIP_ODDS_BOOSTS_AVAILABLE_ACTION_BUTTON_TEXT,
                    },
                },
                IN_USE: {
                    style: {
                        base: {
                            opacity: '0.5',
                        },
                    },
                },
            },
            infoTooltip: {
                infoButton: {
                    buttonIcon: icon(PALETTE.BETSLIP_ODDS_BOOSTS_INFO_ICON_COLOR, 'info'),
                },
                title: {
                    style: PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_TITLE_TEXT,
                },
                text: {
                    style: PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_DESCRIPTION_TEXT,
                },
                expiry: {
                    style: PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_EXPIRATION_TEXT,
                },
            },
            popover: {
                closeButton: {
                    buttonIcon: icon(PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_CLOSE_BUTTON.CLOSE_BUTTON_ICON_COLOR),
                },
                popup: generateSimplePopover(
                    PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_BG,
                    PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_BORDER_RADIUS,
                    PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_SHADOW,
                    PALETTE.BETSLIP_ODDS_BOOSTS_POPOVER_BORDER_COLOR
                ),
            },
        },
    };
}
